
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiGateway, Plan } from 'cw-backend';
import { SnackBarService } from 'cw-utils';

@Injectable()
export class PlanEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    plan: Plan;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getPlan()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getPlan(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('plan/' + this.routeParams.id).subscribe((res: Plan ) => {
                    this.plan = res;
                    this.onDataChanged.next(this.plan);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(plan): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('plan/', plan).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(plan): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('plan/', plan).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(plan): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('plan/' + plan.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }
}
